import Emotion from "../Components/Face-Api";
import Particles from "../Components/Particles";

export default function Student() {
    return (
        <div>
            <Particles/>
            <Emotion />
                    

            {/*
                ALSO SHOUILD PROB ROUND THE ARRRAY VALUES OFF IN THE face-api.js FILE

            */}
        </div>
    )
}